define('components/course/radio-channel',[
    'components/radio-channel/radio-channel'
], function (RadioChannel) {
    "use strict";

    var channelName = 'module-player',
        eventHash;

    eventHash = {
        "Display": {
            "GlobalElements": {
                "SET": null,
                "UPDATE": null
            }
        },

        "Module": {
            "COMPLETE": null,
            "EXIT": null,
            "GET": null,
            "NAV_DIRECTION": null,

            "Badge": {
                "UPDATE": null
            },

            "State": {
                "Save": {
                    "COMPLETE": null,
                    "ERROR": null,
                    "INIT": null,
                    "SUCCESS": null
                }
            }
        },

        "ResourceLoader": {
            "COMPLETE": null
        },

        "Section": {
            "Before": {
                "CHANGE": null
            },

            "ACTIVE": null,
            "CHANGE": null,
            "COMPLETE": null,
            "FROM_SLIDE": null,
            "GOTO": null,
            "NEXT": null,
            "PREV": null
        },

        "Slide": {
            "InstructionsModal": {
                "SHOW": null
            },

            "Transcript": {
                "CLOSE": null,
                "OPEN": null,
                "TOGGLE": null
            },

            "ACTIVE": null,
            "CHANGE": null,
            "COMPLETE": null,
            "FROM_GUID": null,
            "NEXT": null,
            "PREV": null,
            "SHOW": null
        },

        "Theme": {
            "CLEAR": null,
            "CURRENT": null,
            "GET": null,
            "SET": null,
            "UPDATE": null
        }
    };

    return RadioChannel.create(channelName, eventHash);
});

